var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProtocolProfile(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M56 29.334C56 22.9688 53.4714 16.8643 48.9706 12.3634C44.4697 7.86255 38.3652 5.33398 32 5.33398C25.6348 5.33398 19.5303 7.86255 15.0294 12.3634C10.5286 16.8643 8 22.9688 8 29.334C8 39.7873 14.6933 48.6407 24 51.9473V58.6673H29.3333V53.174C31.1046 53.39 32.8954 53.39 34.6667 53.174V58.6673H40V51.9473C49.3067 48.6407 56 39.7873 56 29.334ZM32 48.0007C21.7067 48.0007 13.3333 39.6273 13.3333 29.334C13.3333 19.0407 21.7067 10.6673 32 10.6673C42.2933 10.6673 50.6667 19.0407 50.6667 29.334C50.6667 39.6273 42.2933 48.0007 32 48.0007Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.3334 18.666H42.6667V23.9993H21.3334V18.666ZM34 26.666L26 34.666L29.3334 37.9993L26 41.3327L30 45.3327L38 37.3327L34.6667 33.9993L38 30.666L34 26.666Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProtocolProfile);
export default __webpack_public_path__ + "static/media/protocolProfile.d1466c81612127d92c1594a0e789f9aa.svg";
export { ForwardRef as ReactComponent };